import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-right-icon',
  templateUrl: './communication-right.component.html'
})
export class CommunicationRightComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
